import {
  Button,
  Checkbox,
  Divider,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { useGlobalContext } from "context/GlobalContext";
import React, { useEffect, useState } from "react";
import { FormControlWrapper } from "components/Wrappers/FormComponentsWrappers/FormControlWrapper";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { useProductContext } from "../context";
import {
  PRODUCT_FORM_LABELS,
  PRODUCT_REFERENCE_TYPE,
} from "../constants/product.constants";
import { ProductTopBanner } from "../components/ProductTopBanner";
import { fetchProductCategoriesApi } from "API/apis/master/getProductCategory";

import { message } from "constants/responses/message";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import dayjs from "configs/dayjs.config";

import { fetchUomApi } from "API/apis/master/getUom";
import { fetchPcdCodeApi } from "API/apis/master/getPcdCode";
import { useParams } from "react-router-dom";
import { Box } from "@mui/system";
import { LotFields } from "../components/LotFields";
import { addProductsApi } from "API/apis/product/addProducts";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { uploadFileApi } from "API/apis/files/uploadFile";
import AddIcon from "@mui/icons-material/Add";
import { SingleSelect } from "components/Select/SingleSelect";
import { fetchCurrentProjectProductsApi } from "API/apis/master/getCurrentProjectProducts";
import { DatePickerWrapper } from "components/DateTimePicker/DatePicker";
import { fetchProductFromIdApi } from "API/apis/product/getProductFromId";

const initialState = {
  pcd: 0,
  projectId: 0,
  productName: "",
  productCategory: 0,
  isPcdRequired: false,
  productQuantity: 0,
  refImage: "",
  productUom: 0,
  deliveryDate: new Date(),
  link: "",
  sellingPrice: 0,
  costPrice: 0,
  partsCount: 0,
  lotProcessing: [],
  isLotProcessed: false,
  referenceType: "NEW",
  partNames: [],
};

export const AddProduct = () => {
  const { setError, setSuccess, setIsLoading, setIsInitializing } =
    useGlobalContext();
  const { setReloadRequired } = useProductContext();
  const { projectId } = useParams();
  const [categoryResponse, setCategoryResponse] = useState([]);
  const [referenceType, setReferenceType] = useState("NEW");
  const [uomResponse, setUomResponse] = useState([]);
  const [referenceProductSelect, setReferenceProductSelect] = useState([]);
  const [lotDetails, setLotDetails] = useState([]);
  const [partsCount, setPartsCount] = useState();
  const [partsDetails, setPartsDetails] = useState([]);
  const [isPartDetailChanged, setIsPartDetailChanged] = useState(false);
  const [lotMatrix, setLotMatrix] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [partNames, setPartNames] = useState([]);
  const [formData, setFormData] = useState({ ...initialState, projectId });
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const initialLotDetail = [];
    partsDetails.forEach((item) => {
      const initialValue = [];
      for (let i = 0; i < item; i++) {
        initialValue.push({ quantity: null, deadline: new Date() });
      }
      initialLotDetail.push(initialValue);
    });
    setPartNames(Array(partsCount).fill(""));
    setLotDetails(initialLotDetail);
  }, [isPartDetailChanged]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsInitializing(true);
        if (formData.referenceType === "PCD") {
          const { data, status } = await fetchPcdCodeApi();
          if (status !== 200) {
            throw new Error(message.error.generalFailure);
          }
          setReferenceProductSelect(
            data.map((item) => ({
              option: item.id,
              value: `${item.docCode} | ${item.productName} | ${item.parentCategory} | ${item.childCategory}`,
            }))
          );
        } else if (formData.referenceType === "VARIANT") {
          const { data, status } = await fetchCurrentProjectProductsApi(
            projectId
          );
          if (status !== 200) {
            throw new Error(message.error.generalFailure);
          }
          setReferenceProductSelect(
            data.map((item) => ({
              option: item.id,
              value: `${item.docCode} | ${item.productName} | ${item.parentCategory} | ${item.childCategory}`,
            }))
          );
        } else {
          setReferenceProductSelect([]);
          setFormData({ ...formData, reference: 0 });
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setIsInitializing(false);
        setIsLoading(false);
        setReloadRequired(false);
      }
    };
    fetchData();
  }, [formData.referenceType]);

  useEffect(() => {
    const elem = [];
    partsDetails.forEach((item, index) => {
      elem.push(
        <LotFields
          lotDetails={lotDetails}
          setLotDetails={setLotDetails}
          index={index}
          key={index}
          handleDeleteLotProcessing={handleDeleteLotProcessing}
          handleDeletePart={handleDeletePart}
          handleAddLotProcessing={handleAddLotProcessing}
          partNames={partNames}
          setPartNames={setPartNames}
        />
      );
    });
    setLotMatrix(elem);
  }, [partsDetails, lotDetails]);

  useEffect(() => {
    const fetchData = async () => {
      if (formData.reference) {
        const { data, status } = await fetchProductFromIdApi(
          formData.reference
        );
        if (status !== 200) {
          throw new Error(message.error.generalFailure);
        }
        setFormData({
          ...formData,
          productName: data.productName,
          productCategory: data.productCategoryId,
          productUom: data.productUom,
        });
        setIsDisabled(true);
      }
    };
    fetchData();
  }, [formData.reference]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsInitializing(true);
        const promises = [fetchProductCategoriesApi(), fetchUomApi()];

        const [categoryResponse, uomResponse] = await Promise.all(promises);

        if (categoryResponse.status !== 200 && uomResponse.status !== 200) {
          throw new Error(message.error.generalFailure);
        }

        setCategoryResponse(
          categoryResponse.data.map((item) => ({
            option: item.id,
            value: item.childCategory,
          }))
        );
        setUomResponse(
          uomResponse.data.map((item) => ({
            option: item.key,
            value: item.value,
          }))
        );
        setIsInitializing(false);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsInitializing(false);
        setIsLoading(false);
        setReloadRequired(false);
      }
    };
    fetchData();
  }, []);

  const handleDeletePart = (parentIndex) => {
    const temp = lotDetails.filter((item, index) => index != parentIndex);
    const tempPartDetail = partsDetails.filter(
      (item, index) => index !== parentIndex
    );
    setPartsDetails(tempPartDetail);
    setPartsCount(partsCount - 1);
    setLotDetails(structuredClone(temp));
  };
  const handleAddLotProcessing = (parentIndex) => {
    const temp = structuredClone(lotDetails);
    temp[parentIndex].push({
      quantity: null,
      deadline: new Date(),
    });
    setLotDetails(structuredClone(temp));
  };
  const handleSelectChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleIsPCDRequired = (newValue) => {
    setFormData({
      ...formData,
      isPcdRequired: newValue,
    });
  };
  const handleIsLotProcessed = (newValue) => {
    setFormData({
      ...formData,
      isLotProcessed: newValue,
    });
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      projectId: Number(projectId),
      [e.target.name]: e.target.value,
    });
  };
  const handleDeliveryDateChange = (newValue) => {
    if (newValue) {
      setFormData({
        ...formData,
        deliveryDate: newValue.toDate(),
      });
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0] || null;
    setSelectedFile(file);
  };

  const handleDeleteLotProcessing = (parentIndex, childIndex) => {
    const temp = structuredClone(lotDetails);
    const newArray = temp[parentIndex].filter(
      (item, index) => index !== childIndex
    );
    temp[parentIndex] = newArray;
    setLotDetails(structuredClone(temp));
  };
  const handleAddNewPart = () => {
    setPartsDetails([...partsDetails, 1]);
    setPartsCount(partsCount + 1);
    setLotDetails([...lotDetails, [{ quantity: 0, deadline: new Date() }]]);
  };

  const handleAddNewUserSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      if (selectedFile) {
        const formFileData = new FormData();
        formFileData.append("file", selectedFile);
        const { data: fileUploadData, status: fileUploadStatus } =
          await uploadFileApi(formFileData);
        if (fileUploadStatus !== STATUS_CODES.SUCCESS) {
          throw new Error(fileUploadData.message);
        }

        const { data, status } = await addProductsApi({
          ...formData,
          lotProcessing: lotDetails,
          partNames,
          refImage: fileUploadData.filePath,
        });
        if (status !== STATUS_CODES.SUCCESS) {
          throw new Error(data.message);
        }
        setSuccess(message.success.addedSuccessfully);
      } else {
        const { data, status } = await addProductsApi({
          ...formData,
          partNames,
          lotProcessing: lotDetails,
        });
        if (status !== STATUS_CODES.SUCCESS) {
          throw new Error(data.message);
        }
        setSuccess(message.success.addedSuccessfully);
      }
      setReloadRequired(true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error.message);
    }
  };

  return (
    <>
      <PageTitle pageName={pageName.product.newProduct} />
      <ProductTopBanner buttonType="back" />
      <form onSubmit={handleAddNewUserSubmit}>
        <SingleSelect
          label="Reference Type"
          name="referenceType"
          options={PRODUCT_REFERENCE_TYPE}
          handleSelectSingle={handleSelectChange}
          selectedOption={formData.referenceType}
        />
        {referenceProductSelect.length > 0 && (
          <SingleSelect
            label="Select Reference"
            name="reference"
            options={referenceProductSelect}
            handleSelectSingle={handleSelectChange}
            selectedOption={formData.reference}
          />
        )}
        <FormControlWrapper fullWidth>
          <Typography variant="h6">Upload Reference Image</Typography>
          <TextField
            type="file"
            onChange={handleFileChange}
            InputLabelProps={{ shrink: true }}
            inputProps={{ accept: "image/*" }} // Accept only images
            fullWidth
          />
        </FormControlWrapper>
        {referenceType === "PCD" || (
          <FormControlWrapper>
            <FormLabel>
              {PRODUCT_FORM_LABELS.isPcdRequired}
              <Checkbox
                aria-label="Is PCD Require"
                defaultChecked
                value={formData.isPcdRequired}
                onChange={(e, newValue) => handleIsPCDRequired(newValue)}
              />
            </FormLabel>
          </FormControlWrapper>
        )}
        <TextFieldWrapper
          id="productName"
          name="productName"
          label="Product Name"
          variant="outlined"
          value={formData.productName}
          fullWidth
          required
          onChange={handleChange}
        />
        <SingleSelect
          label="Product Category"
          name="productCategory"
          options={categoryResponse}
          handleSelectSingle={handleSelectChange}
          selectedOption={formData.productCategory}
          isDisabled={isDisabled}
        />
        <FlexBox>
          <TextFieldWrapper
            id="productQuantity"
            name="productQuantity"
            label="Quantity"
            variant="outlined"
            value={formData.productQuantity}
            fullWidth
            required
            onChange={handleChange}
          />
          <SingleSelect
            label="UOM"
            name="productUom"
            options={uomResponse}
            handleSelectSingle={handleSelectChange}
            selectedOption={formData.productUom}
            isDisabled={isDisabled}
          />
        </FlexBox>
        <FlexBox>
          <TextFieldWrapper
            id="costPrice"
            name="costPrice"
            label="Cost Price"
            variant="outlined"
            value={formData.costPrice}
            fullWidth
            required
            onChange={handleChange}
          />
          <TextFieldWrapper
            id="sellingPrice"
            name="sellingPrice"
            label="Selling Price"
            variant="outlined"
            value={formData.sellingPrice}
            fullWidth
            required
            onChange={handleChange}
          />
        </FlexBox>
        <DatePickerWrapper
          label="Delivery Date"
          value={dayjs(formData.deliveryDate)}
          onChange={(newValue) => handleDeliveryDateChange(dayjs(newValue))}
        />
        <TextFieldWrapper
          id="link"
          name="link"
          label="Link"
          variant="outlined"
          value={formData.link}
          fullWidth
          onChange={handleChange}
        />
        <Divider />
        <FormControlWrapper>
          <FormLabel>
            {PRODUCT_FORM_LABELS.isLot}
            <Checkbox
              aria-label={PRODUCT_FORM_LABELS.isLot}
              value={formData.isLotProcessed}
              onChange={(e, newValue) => handleIsLotProcessed(newValue)}
            />
          </FormLabel>
        </FormControlWrapper>
        {formData.isLotProcessed && (
          <Box>
            {lotMatrix}
            <FlexBox justifyContent="center">
              <FormControlWrapper>
                <Button onClick={handleAddNewPart} variant="contained">
                  <AddIcon />
                </Button>
              </FormControlWrapper>
            </FlexBox>
          </Box>
        )}

        <FlexBox>
          <Button variant="contained" type="submit" fullWidth>
            Submit
          </Button>
          <Divider variant="middle" />
        </FlexBox>
      </form>
    </>
  );
};
